import { changeFilter as categoryChangeFilter, changeSort as categoryChangeSort, changePage as actionChangePage } from '@nykaa/listing-shared/category/store/action';
import { searchListingSortOptions, sortCategoryListOptions } from '@nykaa/listing-shared/constants/filter';
import { changePage, changeFilter, changeSort } from '@nykaa/listing-shared/search/store/actions';


export const forNextPage = (isSearch: boolean) => isSearch ? changePage : actionChangePage;
export const forFilterChange = (isSearch: boolean) => isSearch ? changeFilter : categoryChangeFilter;
export const forSortChange = (isSearch: boolean) => isSearch ? changeSort : categoryChangeSort;
export const getStoreName = (isSearch: boolean) => isSearch ? 'searchListingPage' : 'categoryListing';
export const getSortOption = (isSearch: boolean) => isSearch ? searchListingSortOptions : sortCategoryListOptions;
